import { get as dig } from 'lodash';
import { useQuery } from '@apollo/client';
import GET_PROJECT_HAS_COLLABORATIONS from '../gql/ProjectHasCollaborationsQuery.graphql';

const useIsCollaborating = (projectNodeId) => {
  const { data } = useQuery(GET_PROJECT_HAS_COLLABORATIONS, {
    variables: { id: projectNodeId },
  });

  return dig(data, 'viewer.project.hasCollaborations', false);
};

export default useIsCollaborating;
